import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './shared';
export function Guarantee() {
  return <Section className="bg-slate-50 py-16 sm:py-20" data-id="element-108" data-mp="1o2vgwo0xkl61">
      <div className="mx-auto max-w-3xl rounded-3xl border border-gold/40 bg-navy p-8 text-center text-white sm:p-12" data-id="element-109" data-mp="223ekniyd552e">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold/15 text-gold" data-id="element-110" data-mp="1x3tpljmbdguy">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-111" data-mp="19dz8uqyvj85f" />
        </div>
        <h2 className="mt-6 font-display text-2xl font-extrabold text-gold-soft sm:text-3xl" data-id="element-112" data-mp="14g67cb8in2bh">
          🛡️ GARANTÍA 45 DÍAS — SIN PREGUNTAS
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-blue-100/90 sm:text-lg" data-id="element-113" data-mp="1j5vb8e7ztkfg">
          Abrís los módulos. Usás los scripts. Aplicás los protocolos en tu trabajo real. Si en 45 días
          no es exactamente lo que esperabas: devolución del 100% del dinero. Sin formularios. Sin drama.
          Sin preguntas.
        </p>
        <p className="mt-6 inline-block rounded-full bg-white/10 px-5 py-2 font-semibold text-white" data-id="element-114" data-mp="p01j2cs0vbcd">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </Section>;
}